import { axios } from '@/api/axios'
import Pub from '@/utils/public'

// 服务器代理地址
const BASE_URL_HEPAI = process.env.VUE_APP_API_BASE_URL_HEPAI

// --------------------------《 支 付 安 全 》相关的合拍接口

// 开启支付密码
export function openMobilePassword (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/open_password',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 修改支付密码
export function modifyMobilePassword (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/edit_password',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 发送验证码
export function sendSmsCode (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/sms_code',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 忘记支付密码
export function forgetMobilePassword (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/forget_password',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 设置支付密码
export function setMobilePassword (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/set_password',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 关闭支付密码
export function closeMobilePassword (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/close_password',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 用户信息
export function getMobileUserinfo (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/userinfo',
    method: 'get',
    params: parameter
  })
}

// 支付 - 校验支付密码
export function checkPassword (parameter) {
  return axios({
    url: BASE_URL_HEPAI + '/mobile/user/check_password',
    method: 'post',
    data: Pub.TRANSFORM_TO_FORMDATA(parameter),
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 广告主账户余额
export function AdvRecharge () {
  return axios({
    url: BASE_URL_HEPAI + '/advertiser/financial/recharge',
    method: 'get'
  })
}
